import { render, staticRenderFns } from "./WebLinks.vue?vue&type=template&id=af4568a2&scoped=true&"
import script from "./WebLinks.vue?vue&type=script&lang=js&"
export * from "./WebLinks.vue?vue&type=script&lang=js&"
import style0 from "./WebLinks.vue?vue&type=style&index=0&id=af4568a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4568a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
